
<div :class="validationDivClasses">
  <input
    ref="input"
    class="form-control form-control-sm"
    v-bind:value="value"
    v-on:input="handleInput($event.target.value)"
  />
</div>
